import { render, staticRenderFns } from "./ListPermissionPage.vue?vue&type=template&id=48290a3a&"
import script from "./ListPermissionPage.vue?vue&type=script&lang=js&"
export * from "./ListPermissionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports